module.exports = __webpack_public_path__ + "img/france-ischemic-heart-disease-male.47814917.png";